@if(data) {
  <div class="space-y-2">
    <p class="text-black tracking-wide text-lg"><span class="font-semibold">Study Type:</span> {{ studyType }}</p>
    <p class="text-black tracking-wide text-lg"><span class="font-semibold">Phase Type:</span> {{ phaseType }}</p>
    <p class="text-black tracking-wide text-lg"><span class="font-semibold">Trial Type:</span> {{ trialType.join(', ') }}</p>
  </div>
}
  